/** German strings for main (race runtime, HUD, results, share, fatal screens). Keys are the exact English source text. */
export const DE_MAIN_B: Readonly<Record<string, string>> = {
  // Lobby / connection toasts
  'You are now the host — the lobby controls are yours': 'Du bist jetzt Host — die Lobby gehört dir',
  'The host role moved to another driver': 'Die Host-Rolle ist an einen anderen Fahrer gegangen',
  '{name} joined the lobby': '{name} ist der Lobby beigetreten',
  '{name} left the lobby': '{name} hat die Lobby verlassen',
  'A driver left the lobby': 'Ein Fahrer hat die Lobby verlassen',
  '{name} lost connection — their car is held for a reconnect': '{name} hat die Verbindung verloren — das Auto wartet auf die Rückkehr',
  'A driver lost connection — their car is held for a reconnect': 'Ein Fahrer hat die Verbindung verloren — das Auto wartet auf die Rückkehr',
  'Unable to initialise the 3D race engine.': 'Die 3D-Renn-Engine konnte nicht gestartet werden.',
  'Signal lost — local control stays active while race control reconnects': 'Signal verloren — du fährst lokal weiter, während die Rennleitung neu verbindet',
  'Race control resynchronised': 'Rennleitung wieder synchron',
  'LIVE': 'LIVE',
  'OFFLINE // LOCAL SIM': 'OFFLINE // LOKALE SIM',
  'RECONNECTING // LOCAL CONTROL': 'VERBINDE NEU // LOKALE STEUERUNG',
  'CONNECTING': 'VERBINDE',
  'CLOSED': 'GETRENNT',
  'OPEN': 'VERBUNDEN',
  'Party moved, but no valid invite credential is available': 'Die Gruppe ist umgezogen, aber es liegt keine gültige Einladung vor',
  'Party moved together // New grid ready': 'Gruppe gemeinsam umgezogen // Neue Startaufstellung bereit',
  'The lobby is open again — join when you are done here': 'Die Lobby ist wieder offen — steig ein, wenn du hier fertig bist',

  // Recover / rewind
  'Rewind to your last safe line (2 charges, costs 25 nitro)': 'Zurück zur letzten sicheren Linie (2 Ladungen, kostet 25 Nitro)',
  'Reset to track': 'Zurück auf die Strecke',
  'Rewind about three seconds to a safe line. Two charges per race.': 'Etwa drei Sekunden zurück auf eine sichere Linie. Zwei Ladungen pro Rennen.',
  '{n} safe rewind left · costs 25 nitro': 'Noch {n} Rückspulung · kostet 25 Nitro',
  '{n} safe rewinds left · costs 25 nitro': 'Noch {n} Rückspulungen · kostet 25 Nitro',
  'Safe rewinds spent · normal reset remains available': 'Rückspulungen verbraucht · normaler Reset bleibt verfügbar',

  // HUD
  'HEAT {heat} / {total}': 'HEAT {heat} / {total}',
  'HEAT {heat} / {total} · BANK READY': 'HEAT {heat} / {total} · SICHERN BEREIT',
  'BANK LOCKED': 'SICHERN GESPERRT',
  'BANK H{heat}': 'H{heat} SICHERN',
  'WAGER WON': 'WETTE GEWONNEN',
  'WAGER LOST': 'WETTE VERLOREN',
  'MARK // {name}': 'ZIEL // {name}',
  '{ko} KO · {points} PTS': '{ko} KO · {points} PKT',
  'WIN': 'SIEG',
  'OUT': 'RAUS',
  'YOU': 'DU',
  'AI': 'KI',
  'GRIP': 'GRIP',
  'DRIFT': 'DRIFT',
  'BULLY': 'RAMBO',
  'SPRINTER': 'SPRINTER',
  'TRICKSTER': 'TRICKSER',
  'front': 'vorne',
  'rear': 'hinten',
  'left': 'links',
  'right': 'rechts',
  'Damage by side: {sides}': 'Schaden je Seite: {sides}',
  'Damage by side: none': 'Schaden je Seite: keiner',
  'Nitro boost, {percent} percent available': 'Nitro-Boost, {percent} Prozent verfügbar',
  'Drift active, {percent} percent rotation': 'Drift aktiv, {percent} Prozent Rotation',
  'Tap to rotate, hold to drift and earn exit nitro': 'Tippen zum Eindrehen, halten zum Driften – bringt Nitro am Ausgang',
  'SLINGSHOT': 'SLINGSHOT',
  'TOO HOT': 'ZU HEISS',
  'HOLD': 'HALTEN',
  'BUILD': 'AUFBAUEN',
  'STYLE CHAIN': 'STYLE-KETTE',
  'BUILD THE CHAIN': 'BAU DIE KETTE AUF',
  'CONTRACT COMPLETE': 'AUFTRAG ERFÜLLT',
  'CONTRACT MISSED': 'AUFTRAG VERFEHLT',
  'Race control is finding another offer.': 'Die Rennleitung sucht ein neues Angebot.',
  'DONE': 'ERLEDIGT',
  'MISS': 'VERFEHLT',
  'SECTOR DUEL': 'SEKTORDUELL',
  'ATTACK': 'ANGRIFF',
  'NITRO TO DEPLOY': 'NITRO ZÜNDEN',
  'HEAT {level}': 'HEAT {level}',
  '{n} INTERCEPTOR': '{n} ABFANGJÄGER',
  '{n} INTERCEPTORS': '{n} ABFANGJÄGER',
  'PURSUIT SEARCHING': 'VERFOLGER SUCHEN',
  'LOW PROFILE': 'UNAUFFÄLLIG',
  'CHAIN LOST': 'KETTE VERLOREN',
  'KEEP IT CLEAN': 'BLEIB SAUBER',
  'WHEELSPIN': 'DURCHDREHER',
  'EASE INTO THE THROTTLE': 'GIB GEFÜHLVOLL GAS',
  'STYLE ×{multiplier} · NITRO EARNED': 'STYLE ×{multiplier} · NITRO VERDIENT',
  '{n}ST': '{n}.',
  '{n}ND': '{n}.',
  '{n}RD': '{n}.',
  '{n}TH': '{n}.',

  // Style actions (from the simulation)
  'GOOD LAUNCH': 'GUTER START',
  'PERFECT LAUNCH': 'PERFEKTER START',
  'DRIFT BOOST': 'DRIFT-BOOST',
  'DRAFT': 'WINDSCHATTEN',
  'COMEBACK': 'COMEBACK',
  'AIR': 'AIRTIME',
  'NEAR MISS': 'KNAPP VORBEI',
  'OVERTAKE': 'ÜBERHOLT',
  'CLEAN PASS': 'SAUBER ÜBERHOLT',
  'REVENGE': 'REVANCHE',
  'RISK LINE': 'RISIKOLINIE',
  'SHORTCUT': 'ABKÜRZUNG',
  'LOOP MASTER': 'LOOPING-PROFI',
  'GOOD CORNER': 'GUTE KURVE',
  'PERFECT CORNER': 'PERFEKTE KURVE',
  'TAKEDOWN': 'TAKEDOWN',
  'BOOST ZONE': 'BOOST-ZONE',
  'PIT CREW': 'BOXENCREW',
  'CROWD LINE': 'PUBLIKUMSLINIE',
  'LIVE CONTRACT': 'LIVE-AUFTRAG',
  'HEAT UP': 'HEAT STEIGT',
  'BANKED': 'GESICHERT',
  'SIGNATURE': 'SIGNATUR',
  'REWIND': 'RÜCKSPULEN',
  'BOSS BLOCK': 'BOSS-BLOCK',
  'BOSS ATTACK': 'BOSS-ANGRIFF',
  'BOSS DRIFT': 'BOSS-DRIFT',
  'BOSS SHORTCUT': 'BOSS-ABKÜRZUNG',

  // Settings / pause
  'RACE PAUSED // OFFLINE': 'RENNEN PAUSIERT // OFFLINE',
  'RACE SYSTEMS': 'RENNSYSTEME',
  'Graphics preparation failed': 'Grafikvorbereitung fehlgeschlagen',
  'OFF': 'AUS',
  'SOUND OFF': 'TON AUS',
  'SOUND ON': 'TON AN',
  'SCENE BUDGET HIGH': 'SZENENBUDGET HOCH',
  'ON BUDGET': 'IM BUDGET',
  'FRAME RATE DIPPING — TRY A LOWER PRESET': 'FPS BRECHEN EIN — PROBIER EIN NIEDRIGERES PRESET',
  'RUNNING SMOOTHLY': 'LÄUFT FLÜSSIG',
  'Graphics recovered — race resumed': 'Grafik wiederhergestellt — weiter geht’s',

  // Ghosts
  '{name} GHOST': '{name}-GHOST',
  'PERSONAL BEST': 'PERSÖNLICHE BESTZEIT',
  'PERSONAL BEST · SAVING': 'BESTZEIT · SPEICHERT',
  'PERSONAL BEST · UNSAVED': 'BESTZEIT · NICHT GESPEICHERT',
  'SPLIT {delta} S': 'SPLIT {delta} S',
  'RACING {name}': 'GEGEN {name}',
  'RACING PERSONAL GHOST': 'GEGEN DEINEN GHOST',
  'RECORDING FIRST LAP': 'ERSTE RUNDE WIRD AUFGEZEICHNET',
  'GHOST STANDBY': 'GHOST BEREIT',
  'BEAT {name}': 'SCHLAG {name}',
  'GOLD {time}': 'GOLD {time}',
  '{medal} RECORD': '{medal}-REKORD',
  'GOLD': 'GOLD',
  'SILVER': 'SILBER',
  'BRONZE': 'BRONZE',
  'NO MEDAL': 'KEINE MEDAILLE',
  'New personal best // {time}': 'Neue Bestzeit // {time}',
  'New personal best // {time} · saving': 'Neue Bestzeit // {time} · wird gespeichert',
  'Personal best is active in this race but could not be saved to this browser.': 'Deine Bestzeit gilt in diesem Rennen, konnte aber nicht im Browser gespeichert werden.',
  'SAVING GHOST…': 'GHOST WIRD GESPEICHERT…',
  'GHOST NOT SAVED': 'GHOST NICHT GESPEICHERT',
  'SHARE DAILY GHOST + QR ↗': 'DAILY-GHOST + QR TEILEN ↗',
  'SHARE GHOST + QR ↗': 'GHOST + QR TEILEN ↗',

  // Controller / fullscreen
  'Controller connected // {name}': 'Controller verbunden // {name}',
  'Controller disconnected — keyboard and touch remain active': 'Controller getrennt — Tastatur und Touch bleiben aktiv',
  'Fullscreen race mode enabled': 'Vollbild-Rennmodus aktiv',
  'Fullscreen mode is unavailable in this browser': 'Vollbild ist in diesem Browser nicht verfügbar',

  // Tilt steering
  'CALIBRATE TILT': 'NEIGUNG KALIBRIEREN',
  'Tilt steering is off. Enable it, hold the device naturally, then tilt to steer.': 'Neigungssteuerung ist aus. Schalte sie ein, halte das Gerät natürlich und neige es zum Lenken.',
  'Waiting for orientation data… move the device slightly.': 'Warte auf Lagedaten… beweg das Gerät leicht.',
  'Tilt steering active. Disable it here to bring back the steering swiper.': 'Neigungssteuerung aktiv. Schalte sie hier aus, um den Lenk-Slider zurückzuholen.',
  'Motion permission was denied. You can retry or steer with the swiper.': 'Bewegungszugriff verweigert. Versuch es erneut oder lenk mit dem Slider.',
  'No sensor data arrived. The steering swiper is active; retry Tilt when the device sensor is available.': 'Keine Sensordaten empfangen. Der Lenk-Slider ist aktiv; versuch die Neigung erneut, sobald der Sensor verfügbar ist.',
  'Tilt steering requires HTTPS on Android. The steering swiper remains available on this HTTP connection.': 'Neigungssteuerung braucht auf Android HTTPS. Über diese HTTP-Verbindung bleibt der Lenk-Slider verfügbar.',
  'DENIED': 'VERWEIGERT',
  'ACTIVE': 'AKTIV',
  'GRANTED / WAITING': 'ERLAUBT / WARTET',
  'NO DATA': 'KEINE DATEN',
  'NOT REQUESTED': 'NICHT ANGEFRAGT',
  'HTTPS / TRUSTED': 'HTTPS / VERTRAUT',
  'HTTP / SENSOR BLOCKED': 'HTTP / SENSOR BLOCKIERT',
  'NO SENSOR API': 'KEINE SENSOR-API',
  'LEGACY CHROME · {mode}': 'ALTES CHROME · {mode}',
  'ORIENTATION': 'LAGE',
  'ACCEL FALLBACK': 'BESCHL.-FALLBACK',
  'ORIENTATION + ACCEL': 'LAGE + BESCHL.',
  'ORIENTATION ONLY': 'NUR LAGE',
  'DISABLE TILT': 'NEIGUNG AUS',
  'RETRY TILT STEERING': 'NEIGUNG ERNEUT VERSUCHEN',
  'ENABLE TILT STEERING': 'NEIGUNGSSTEUERUNG AN',
  'TILT MODE': 'NEIGUNG',
  'TILT STARTING': 'NEIGUNG STARTET',
  'TOUCH MODE': 'TOUCH',
  'TAP FOR SWIPER': 'TIPPEN FÜR SLIDER',
  'TAP FOR TILT': 'TIPPEN FÜR NEIGUNG',
  'DEVICE ORIENTATION': 'GERÄTELAGE',
  'GRAVITY ACCELEROMETER': 'SCHWERKRAFT-SENSOR',
  'LEFT': 'LINKS',
  'RIGHT': 'RECHTS',
  'CENTRE': 'MITTE',
  'CENTRED 0%': 'MITTIG 0%',
  'Enable Tilt and wait for live sensor data before calibration': 'Schalte die Neigung ein und warte auf Sensordaten, bevor du kalibrierst',
  'CALIBRATING…': 'KALIBRIERE…',
  'Hold the device naturally and keep it centred': 'Halte das Gerät natürlich und mittig',
  'Tilt comfortably left and right — no need to force full travel': 'Neig es locker nach links und rechts — kein voller Ausschlag nötig',
  'Calibration saved — centre and both steering directions detected': 'Kalibrierung gespeichert — Mitte und beide Lenkrichtungen erkannt',
  'Neutral saved — drive normally and Tilt will keep learning your range': 'Mitte gespeichert — fahr einfach los, die Neigung lernt deinen Bereich weiter',
  'CALIBRATE AGAIN': 'NEU KALIBRIEREN',
  'Tilt calibration complete': 'Neigung kalibriert',
  'Tilt neutral saved; range will keep learning': 'Neigungsmitte gespeichert; der Bereich wird weiter gelernt',

  // Network badge
  'REAL-TIME RACE NETWORK': 'ECHTZEIT-RENNNETZ',
  'OFFLINE SOLO READY': 'OFFLINE SOLO BEREIT',

  // Results
  'DAILY CHALLENGE COMPLETE': 'DAILY CHALLENGE GESCHAFFT',
  'TIME TRIAL COMPLETE': 'ZEITFAHREN BEENDET',
  'STREET SPRINT RESULTS': 'STREET-SPRINT-ERGEBNIS',
  'STYLE RUSH RESULTS': 'STYLE-RUSH-ERGEBNIS',
  'LAST DRIVER STANDING': 'LETZTER IM RENNEN',
  'HEAT BANKED': 'HEAT GESICHERT',
  'HEAT LOST': 'HEAT VERLOREN',
  'ROAD RAGE RESULTS': 'ROAD-RAGE-ERGEBNIS',
  'FINAL ORDER': 'ENDSTAND',
  'YOUR FINISH': 'DEIN ZIELEINLAUF',
  'YOUR RESULT': 'DEIN ERGEBNIS',
  'OF {total} · {car}': 'VON {total} · {car}',
  'HEAT {heat} · SCORE {score}': 'HEAT {heat} · PUNKTE {score}',
  '{takedowns} TAKEDOWNS · {points} PTS': '{takedowns} TAKEDOWNS · {points} PKT',
  'STYLE {score}': 'STYLE {score}',
  'WINNER': 'SIEGER',
  'FINISHED': 'IM ZIEL',
  'DNF': 'DNF',
  'BUST': 'GESCHNAPPT',
  'SCORED': 'GEWERTET',
  'LATEST FLYING LAP': 'LETZTE FLIEGENDE RUNDE',
  'SECTOR {n}': 'SEKTOR {n}',
  'GOLD {gold} · SILVER {silver} · BRONZE {bronze}': 'GOLD {gold} · SILBER {silver} · BRONZE {bronze}',
  'OPTIONAL WAGER': 'OPTIONALE WETTE',
  'WON · +{xp} XP': 'GEWONNEN · +{xp} XP',
  'MISSED · {progress} / {target}': 'VERFEHLT · {progress} / {target}',
  'ARCADE LAB': 'ARCADE-LABOR',
  'CUSTOM EVENT': 'EIGENES EVENT',
  'NO CAREER SAVE': 'KEIN KARRIERE-SPEICHERN',
  'This playful ruleset keeps career XP, records, ghosts and vehicle mastery untouched.': 'Dieses verspielte Regelwerk lässt Karriere-XP, Rekorde, Ghosts und Fahrzeugmeisterschaft unberührt.',
  'LOCAL STREET CAREER': 'LOKALE STRASSENKARRIERE',
  'LV {level} // {rank}': 'LV {level} // {rank}',
  'ALREADY BANKED': 'BEREITS GESICHERT',
  'LEVEL UP': 'LEVEL-UP',
  'MAX RANK': 'MAX. RANG',
  '{current} / {required} TO NEXT RANK': '{current} / {required} BIS ZUM NÄCHSTEN RANG',
  'Finish, style, and take risks to bank career XP.': 'Komm ins Ziel, zeig Style und geh Risiken ein, um Karriere-XP zu sichern.',
  'CONTRACTS CLEARED': 'AUFTRÄGE ERLEDIGT',
  'DAILY': 'TÄGLICH',
  'WEEKLY': 'WÖCHENTLICH',
  'TRACK MASTERY // {map}': 'STRECKENMEISTERSCHAFT // {map}',
  'UNRANKED': 'OHNE RANG',
  'NEW // {goals}': 'NEU // {goals}',
  'Keep racing this district to raise mastery.': 'Fahr weiter in diesem Viertel, um deine Meisterschaft zu steigern.',
  'RIVAL REPORT': 'RIVALENBERICHT',
  'W': 'S',
  'L': 'N',
  '{n} WIN STREAK': '{n} SIEGE IN FOLGE',
  '{n} LOSS STREAK': '{n} NIEDERLAGEN IN FOLGE',
  'NEXT UNLOCK': 'NÄCHSTE BELOHNUNG',
  'LEVEL {level}': 'LEVEL {level}',
  'ALL CAREER REWARDS UNLOCKED': 'ALLE KARRIERE-BELOHNUNGEN FREIGESCHALTET',
  'VEHICLE MASTERY // {car}': 'FAHRZEUGMEISTERSCHAFT // {car}',
  '{done} / {total} GOALS': '{done} / {total} ZIELE',
  'UNLOCKED // {paint} MASTERY PAINT': 'FREIGESCHALTET // {paint}-MEISTERLACKIERUNG',
  'Drive its signature to complete all three goals.': 'Fahr seinen Signature-Stil, um alle drei Ziele zu schaffen.',
  'NIGHT TOUR // {tour}': 'NACHTTOUR // {tour}',
  'TOUR COMPLETE': 'TOUR GESCHAFFT',
  'STAGE {stage} / {total}': 'ETAPPE {stage} / {total}',
  '{points} PTS': '{points} PKT',
  'RIVAL BOSSES': 'RIVALEN-BOSSE',
  '{reward} UNLOCKED · SERIES COMPLETE.': '{reward} FREIGESCHALTET · SERIE GESCHAFFT.',
  'NEXT // {event}': 'NÄCHSTES // {event}',
  'RETRY // {event}': 'NOCHMAL // {event}',
  'BACK TO LOBBY': 'ZURÜCK ZUR LOBBY',
  'Same crew, next race': 'Gleiche Crew, nächstes Rennen',
  'MAIN MENU': 'HAUPTMENÜ',
  'LEAVE SESSION': 'SITZUNG VERLASSEN',
  'RETRY TOUR EVENT ↻': 'TOUR-EVENT WIEDERHOLEN ↻',
  'NEXT TOUR EVENT →': 'NÄCHSTES TOUR-EVENT →',
  'NEXT EVENT →': 'NÄCHSTES EVENT →',
  'Local career could not be saved: {reason}': 'Lokale Karriere konnte nicht gespeichert werden: {reason}',
  'Local career save could not be completed.': 'Lokales Karriere-Speichern konnte nicht abgeschlossen werden.',

  // Career labels shown in results (rank titles, XP breakdown, mastery tiers)
  'ROOKIE': 'ROOKIE',
  'STREETWISE': 'STRASSENKUNDIG',
  'NIGHT RUNNER': 'NACHTLÄUFER',
  'APEX HUNTER': 'SCHEITELPUNKTJÄGER',
  'ICON': 'IKONE',
  'NIGHT LEGEND': 'NACHTLEGENDE',
  'CITY HUNTER': 'STADTJÄGER',
  'CITY ICON': 'STADTIKONE',
  'REDLINE ELITE': 'REDLINE-ELITE',
  'TOUR LEGEND': 'TOUR-LEGENDE',
  'STREET CONTRACTS': 'STRASSENAUFTRÄGE',
  'LIVE CONTRACTS': 'LIVE-AUFTRÄGE',
  'TRACK MASTERY': 'STRECKENMEISTERSCHAFT',
  'RACE FINISH': 'ZIELEINLAUF',
  'TIMED EVENT': 'ZEIT-EVENT',
  'FINISHING POSITION': 'ZIELPOSITION',
  'STYLE BANK': 'STYLE-KONTO',
  'CLEAN FINISH': 'SAUBERES FINISH',
  'SURVIVAL': 'ÜBERLEBT',
  'RISK LINES': 'RISIKOLINIEN',

  // Race control callout
  'RACE CONTROL': 'RENNLEITUNG',

  // Share overlay
  'Only standard solo Time Trials can record or share career ghosts': 'Nur normale Solo-Zeitfahren können Karriere-Ghosts aufzeichnen oder teilen',
  'Finish a valid flying lap before sharing a ghost': 'Fahr erst eine gültige fliegende Runde, bevor du einen Ghost teilst',
  'NIGHTSHIFT daily challenge {daily}': 'NIGHTSHIFT Daily Challenge {daily}',
  'NIGHTSHIFT ghost challenge': 'NIGHTSHIFT Ghost-Challenge',
  'Beat {name} daily ghost for {daily}.': 'Schlag den Daily-Ghost von {name} für {daily}.',
  'Beat my daily ghost for {daily}.': 'Schlag meinen Daily-Ghost für {daily}.',
  'Beat {name} on {map}.': 'Schlag {name} auf {map}.',
  'Beat my on {map}.': 'Schlag mich auf {map}.',
  'this route': 'dieser Strecke',
  'DAILY CHALLENGE': 'DAILY CHALLENGE',
  'GHOST CHALLENGE': 'GHOST-CHALLENGE',
  'PRIVATE GRID ACCESS': 'PRIVATER GRID-ZUGANG',
  'BEAT TODAY’S GHOST.': 'SCHLAG DEN GHOST DES TAGES.',
  'BEAT MY GHOST.': 'SCHLAG MEINEN GHOST.',
  'BRING YOUR CREW.': 'HOL DEINE CREW.',
  'Scan or send today’s seeded run. The QR contains the car, track and complete non-colliding ghost.': 'Scanne oder sende den heutigen Lauf. Der QR-Code enthält Auto, Strecke und den kompletten kollisionsfreien Ghost.',
  'Scan or send this compact challenge. It includes the car, track and complete non-colliding racing line.': 'Scanne oder sende diese kompakte Challenge. Sie enthält Auto, Strecke und die komplette kollisionsfreie Ideallinie.',
  'Scan the QR code or send the private link. Anyone who has it can claim an open grid slot before launch.': 'Scanne den QR-Code oder sende den privaten Link. Wer ihn hat, kann sich vor dem Start einen freien Platz im Grid sichern.',
  'DAILY SEEDED TIME ATTACK': 'TÄGLICHE TIME ATTACK',
  'TIME TRIAL CHALLENGE': 'ZEITFAHR-CHALLENGE',
  'ONE LINK // ONE GRID': 'EIN LINK // EIN GRID',
  'CHALLENGE LINK': 'CHALLENGE-LINK',
  'PRIVATE INVITE LINK': 'PRIVATER EINLADUNGSLINK',
  'CHASE THE<br>RACING LINE.': 'JAG DIE<br>IDEALLINIE.',
  'JOIN THE<br>NIGHT SHIFT.': 'KOMM IN DIE<br>NACHTSCHICHT.',
  'QR code containing the daily ghost challenge link': 'QR-Code mit dem Link zur Daily-Ghost-Challenge',
  'QR code containing the Time Trial ghost challenge link': 'QR-Code mit dem Link zur Zeitfahr-Ghost-Challenge',
  'QR code containing the private race invite link': 'QR-Code mit dem privaten Renn-Einladungslink',
  'GENERATING SECURE QR…': 'ERSTELLE SICHEREN QR…',
  'QR UNAVAILABLE': 'QR NICHT VERFÜGBAR',
  'Copy or share the link instead.': 'Kopier oder teil stattdessen den Link.',
  'QR code could not be generated': 'QR-Code konnte nicht erstellt werden',
  'Ghost challenge copied': 'Ghost-Challenge kopiert',
  'Invite link copied': 'Einladungslink kopiert',
  'Copy this ghost challenge link:': 'Kopier diesen Ghost-Challenge-Link:',
  'Copy this private race link:': 'Kopier diesen privaten Rennlink:',
  'NIGHTSHIFT private race': 'NIGHTSHIFT Privatrennen',
  'Take a grid slot in my NIGHTSHIFT race.': 'Sicher dir einen Platz in meinem NIGHTSHIFT-Rennen.',
  'Could not open the system share menu': 'Das Teilen-Menü konnte nicht geöffnet werden',

  // Spectator
  'This live session is no longer available.': 'Diese Live-Sitzung ist nicht mehr verfügbar.',
  'The spectator view could not process live data: {reason}': 'Die Zuschaueransicht konnte die Live-Daten nicht verarbeiten: {reason}',
  'The party moved, but this spectator link has no reusable invite': 'Die Gruppe ist umgezogen, aber dieser Zuschauerlink enthält keine wiederverwendbare Einladung',
  'Pit wall moved to the next grid': 'Kommandostand ist zum nächsten Grid umgezogen',
  'GRID FORMING': 'GRID FORMIERT SICH',
  'START IN {seconds}': 'START IN {seconds}',
  'RACE LIVE': 'RENNEN LÄUFT',
  'FINAL CLASSIFICATION': 'ENDWERTUNG',
  '{n} DRIVERS': '{n} FAHRER',
  '{n} WATCHING': '{n} SCHAUEN ZU',
  '{n} LAP': '{n} RUNDE',
  '{n} LAPS': '{n} RUNDEN',
  'LAP {lap}/{total}': 'RUNDE {lap}/{total}',

  // Camera
  'CHASE': 'VERFOLGER',
  'CLOSE': 'NAH',
  'TOP': 'OBEN',
  'HOOD': 'HAUBE',
  'COCKPIT': 'COCKPIT',
  'chase': 'Verfolger',
  'close': 'nah',
  'top': 'oben',
  'hood': 'Haube',
  'cockpit': 'Cockpit',
  'Current camera: {mode}': 'Aktuelle Kamera: {mode}',
  'Change camera. Current view: {mode}': 'Kamera wechseln. Aktuelle Ansicht: {mode}',

  // Notifications
  'No race control messages yet.': 'Noch keine Meldungen der Rennleitung.',

  // Fatal / takeover / update / offline screens
  'SESSION<br>UNAVAILABLE': 'SITZUNG<br>NICHT VERFÜGBAR',
  'RETURN TO GARAGE': 'ZURÜCK ZUR GARAGE',
  'CONTROL MOVED //': 'STEUERUNG ÜBERNOMMEN //',
  'ANOTHER TAB<br>TOOK OVER': 'EIN ANDERER TAB<br>HAT ÜBERNOMMEN',
  'This race was opened in a newer tab or window, which now owns the controls. This tab has been disconnected so both cannot steer the same car.': 'Dieses Rennen wurde in einem neueren Tab oder Fenster geöffnet, das jetzt die Steuerung hat. Dieser Tab wurde getrennt, damit nicht beide dasselbe Auto lenken.',
  'TAKE OVER HERE ↻': 'HIER ÜBERNEHMEN ↻',
  'GRID CLOSED //': 'GRID GESCHLOSSEN //',
  'PRIVATE INVITATION': 'PRIVATE EINLADUNG',
  'The link may have expired, filled up, or belonged to an older server build.': 'Der Link ist vielleicht abgelaufen, das Grid voll oder er gehört zu einer älteren Server-Version.',
  'UPDATE //': 'UPDATE //',
  'RACE CONTROL HANDSHAKE': 'HANDSHAKE MIT DER RENNLEITUNG',
  'GETTING<br>NEW BUILD': 'NEUE VERSION<br>WIRD GELADEN',
  'Your saved driver and race pass stay on this device. NIGHTSHIFT is activating the compatible client now…': 'Dein Fahrer und dein Rennpass bleiben auf diesem Gerät. NIGHTSHIFT aktiviert jetzt den passenden Client…',
  'OFFLINE //': 'OFFLINE //',
  'LOCAL GARAGE SAFE': 'LOKALE GARAGE SICHER',
  'RADIO<br>SILENCE': 'FUNK-<br>STILLE',
  'Your driver profile, settings and street-career progress are safe on this device. Reconnect to reach race control and get back on the grid.': 'Dein Fahrerprofil, deine Einstellungen und dein Karrierefortschritt sind auf diesem Gerät sicher. Verbinde dich neu, um die Rennleitung zu erreichen und zurück ins Grid zu kommen.',
  'RETRY CONNECTION ↻': 'ERNEUT VERBINDEN ↻',
};
